
export const catoo = {
    nextGenEngine: '新一代**AI创意工作台**，用于即时图像和视频创作',
    heroTitle: '从文字到图像与视频，用Catoo释放您的创造力',
    heroSubtitle: 'AI驱动的内容制作工作空间，支持图像与视频的生成与编辑。',
    getStartedFree: '免费开始',
    viewExamples: '查看示例',
    imageGeneration: '图片生成',
    imageGenerationDesc: '从文字或照片生成高品质图片。',
    videoGeneration: '视频生成',
    videoGenerationDesc: '根据提示词或参考图片生成AI视频。',
    imageToImage: '图像转图像',
    imageToImageDesc: '使用AI驱动的编辑和增强功能转换现有图像。',
    textToImage: '文字转图像',
    textToImageDesc: '使用先进的AI从文字描述生成令人惊叹的图像。',
    aiWorkbench: 'AI工作台',
    aiWorkbenchDesc: '专业的AI驱动图像生成和编辑工作空间。',
    features: '功能特色',
    featuresSubtitle: '为创意专业人士提供强大的AI工具',
    advancedAI: '先进AI模型',
    advancedAIDesc: '最先进的AI技术，提供卓越的图像质量和创造力。',
    multipleFormats: '多种格式',
    multipleFormatsDesc: '支持各种图像格式和分辨率，满足您的需求。',
    fastProcessing: '快速处理',
    fastProcessingDesc: '快速周转时间，提高创意工作流程效率。',
    showcaseTitle: 'Catoo 作品展示',
    showcaseSubtitle: '探索使用我们AI驱动工具创作的惊人作品',
    showcase1Caption: 'AI生成的风景画，细节惊人，色彩鲜艳',
    showcase2Caption: '使用先进AI技术进行的创意肖像转换',
    whatIsTitle: '什么是Catoo？',
    whatIsDesc: 'Catoo是一个全面的AI驱动创意平台，革命性地改变内容创作。',
    unifiedStyle: '所有内容统一视觉风格',
    batchJobs: '批量处理提高工作效率',
    teamCollaboration: '无缝团队协作功能',
    whyChooseTitle: '为什么选择Catoo？',
    qualityControl: '质量控制',
    qualityControlDesc: '先进的AI确保每次都能输出一致的高质量内容。',
    highEfficiency: '高效率',
    highEfficiencyDesc: '简化的工作流程节省时间并提高生产力。',
    costEffective: '成本效益',
    costEffectiveDesc: '可随创意需求扩展的实惠定价计划。',
    howToCreateTitle: '如何使用Catoo创作',
    inputIdea: '输入您的想法',
    inputIdeaDesc: '只需用自然语言描述您想要创作的内容。',
    generateDraft: '生成草稿',
    generateDraftDesc: '我们的AI根据您的规格创建初始草稿。',
    oneClickExport: '一键导出',
    oneClickExportDesc: '一键将您的创作导出为各种格式。',
    capabilitiesTitle: '强大功能',
    imageStudio: '图像工作室',
    imageStudioDesc: '专业的图像生成和编辑工具。',
    storyboard: '故事板',
    storyboardDesc: '轻松创建视觉叙事和故事板。',
    publish: '发布',
    publishDesc: '即时在多个平台分享您的创作。',
    collaborate: '协作',
    collaborateDesc: '与您的团队实时协作。',
    creators: '10,000+ 创作者',
    faster: '5倍更快',
    satisfaction: '98% 满意度',
    pricingTitle: '选择您的计划',
    testimonialsTitle: '用户评价',
    echoName: 'Echo Chen',
    echoTitle: '数字艺术家',
    echoTestimonial: 'Catoo改变了我的创作工作流程。AI驱动的工具非常直观，产生令人惊叹的结果。',
    novaName: 'Nova Kim',
    novaTitle: '内容创作者',
    novaTestimonial: '我可以在几分钟内创建专业质量的内容，而不是几小时。Catoo对内容创作者来说是一个游戏规则改变者。',
    faqTitle: '常见问题',
    faqCommercialUse: '我可以将Catoo用于商业用途吗？',
    faqCommercialUseAnswer: '是的，使用Catoo创建的所有内容都可以无限制地用于商业用途。',
    faqOnPremise: '您提供本地部署解决方案吗？',
    faqOnPremiseAnswer: '是的，我们为有特定安全要求的组织提供企业本地部署解决方案。',
    faqEducationDiscount: '您提供教育折扣吗？',
    faqEducationDiscountAnswer: '是的，我们为教育机构和学生提供特殊定价。请联系我们了解更多详情。',
    faqGeminiNano: 'Catoo 如何让 Gemini Nano 更易于使用？',
    faqGeminiNanoAnswer: 'Catoo 为 Gemini Nano 提供了简化的界面，在后台处理复杂的模型交互，让您可以专注于创作而无需面对技术障碍。',
    faqDifference: 'Catoo 与其他 AI 视频生成工具有什么区别？',
    faqDifferenceAnswer: 'Catoo 将 Sora、Veo 和 Wan 等多个最先进的模型集成到一个易于使用的平台中，并针对速度和用户体验进行了优化。',
    footerTagline: '用AI驱动的工具释放您的创造力',
    contactEmail: '电子邮件: support@catoo.ai',
    productSection: '产品',
    imageUpscaler: '图像放大器',
    pricing: '定价',
    myCreations: '我的创作',
    companySection: '公司',
    about: '关于',
    careers: '职业',
    contact: '联系',
    resourcesSection: '资源',
    showcase: '展示',
    guides: '指南',
    community: '社区',
    privacyPolicy: '隐私政策',
    privacyPolicyPage: {
      lastUpdated: '最新更新：{date}',
      intro: '本隐私政策说明 CatooAI（以下简称“CatooAI”“Catoo”“我们”）在您使用我们的 App、网站、AI 创作工具、订阅与支付服务及相关功能时，如何收集、使用、披露、保存和保护个人信息。',
      section1Title: '1. 适用范围与收集来源',
      section1Content: `我们通过以下三种方式收集信息：（1）您直接向我们提供，例如注册账号、登录、上传内容、购买套餐、联系客服或修改设置时；（2）您使用设备、浏览器或服务过程中自动产生的技术信息；（3）经您授权的第三方或合作方提供的信息，例如 Apple、Google、应用商店或支付服务商。

本政策旨在清楚说明我们收集哪些数据、如何收集、用于什么目的、保存多久，以及您如何申请删除数据或在适用情况下撤回同意。`,
      section2Title: '2. 我们可能收集的信息',
      section2Content: `我们可能收集以下类别的信息：
- 账号与资料信息，例如电子邮箱、显示名称、头像、账号偏好，以及 Apple 或 Google 登录关联标识。
- 购买、订阅与订单信息，例如套餐信息、支付状态、发票、应用商店收据或支付确认令牌。我们不会从支付服务商处获取您的完整银行卡号。
- 您为使用 AI 创作功能而提交的提示词、图片、视频、参考文件、编辑内容及生成结果。
- 为保障服务运行与安全所需的设备、浏览器、IP 地址、应用版本、崩溃数据、性能指标和安全日志等诊断信息。
- 仅在您主动使用需要地图或定位的功能并授予权限时，收集大致位置或精确位置数据。
- 仅在您主动使用相关功能时，访问相机、相册、文件、通知或类似权限所对应的数据。`,
      section3Title: '3. 照片、人脸数据、权限与用户内容',
      section3Content: `CatooAI 的部分功能允许您上传肖像照、证件照、自拍照或其他可能包含人脸的图片。我们仅在您主动使用该类功能时处理此类内容。

我们处理上传图片、提示词和参考文件，仅用于完成您请求的生成、编辑、修复或增强功能。我们不会利用这些内容识别您的身份、推断敏感属性，或建立广告画像。

未经您另行明确授权，我们不会将您上传的照片、提示词或生成内容用于训练模型。您也可以通过设备或浏览器设置管理相机、相册、通知和定位权限。`,
      section4Title: '4. 我们如何使用信息',
      section4Content: `我们仅在与提供和改进服务相关的范围内使用个人信息，包括：
- 创建并交付您请求的 AI 图片、视频、编辑结果及其他生成内容。
- 建立和管理账号、完成登录认证、同步历史记录并提供客服支持。
- 处理购买、验证订阅、防范欺诈、处理退款并保存必要的财务记录。
- 维护系统安全、识别滥用、执行平台规则，并保护用户、创作者及服务本身。
- 排查问题、分析性能并持续改进稳定性、质量与产品体验。
- 发送重要服务通知，例如支付结果、安全提醒或政策更新。
- 遵守适用法律、合法请求及监管义务。`,
      section5Title: '5. 共享与第三方服务',
      section5Content: `我们不会出售个人信息。只有在提供服务或履行法律义务所必需的情况下，我们才会与受信任的第三方共享有限数据。

根据您使用的功能，这些第三方可能包括 Apple 或 Google 等登录服务商；Apple、Stripe、PayPal 或您所在地区/平台适用的支付和计费服务商；包括火山引擎（Volcengine）在内的 AI 基础设施和模型服务商，用于处理提示词和上传内容并生成您请求的结果；以及帮助我们提供托管、存储、安全、日志、邮件、地图或客服能力的服务提供商。

任何代表我们处理用户数据的第三方，都必须按照本隐私政策和适用法律的要求，提供相同或同等水平的数据保护。`,
      section6Title: '6. 保存期限、删除与安全措施',
      section6Content: `只要您的账号处于活跃状态且相关数据仍为提供服务所必需，我们就会保留账号记录、订阅历史和生成内容。

临时上传文件和处理中间产物会在不再需要用于本次任务、客服支持、安全审查或法律合规时被删除或解除关联。您可以从历史记录中删除生成内容，也可以通过 App 内的账号删除流程或联系我们，申请删除账号及符合条件的个人数据。

如为税务、会计、争议处理、拒付防御、反欺诈或其他法律义务所必需，我们可能会延长保留部分记录。我们会采取合理的管理、技术和组织措施，防止个人信息遭到未经授权的访问、丢失、滥用或泄露。`,
      section7Title: '7. 您的权利与选择',
      section7Content: `根据您所在地及适用法律，您可能享有访问、查阅、更正、删除、获取副本、反对或限制处理个人信息的权利。

对于可选处理活动，您也可以撤回同意，并通过设备设置停止向我们提供相机、相册、通知或定位权限。如您不希望继续接收非必要通知，也可以在提供该选项的情况下取消订阅。`,
      section8Title: '8. 未成年人、跨境传输、政策更新与联系方式',
      section8Content: `CatooAI 不面向未达到当地法律允许其独立同意数据处理年龄的儿童。未经适当授权，我们不会故意收集儿童个人信息。

由于我们的服务可能依赖全球化基础设施提供商，您的信息可能会在您所在国家或地区之外被处理。在此情况下，我们会采取适用法律要求的相应保护措施。

我们可能会不时更新本隐私政策。如遇重大变更，我们会在适用情况下通过 App、网站、电子邮件或其他合理方式提前通知您。

如您希望咨询隐私问题、撤回同意或申请删除数据，请联系 support@catoo.ai。`
    },
    termsOfService: '服务条款',
    termsOfServicePage: {
      lastUpdated: '最新更新：{date}',
      intro: '欢迎使用 Catoo。访问或使用我们的服务，即表示您同意受这些条款的约束。',
      accountTerms: {
        title: '账户条款',
        items: {
          age: '您必须年满 18 岁才能使用此服务。',
          security: '您有责任维护账户和密码的安全。',
          responsibility: '您对账户下发生的所有活动负责。'
        }
      },
      usageRules: {
        title: '使用规则',
        items: {
          lawfulUse: '您不得将服务用于任何非法或未经授权的目的。',
          content: '您不得上传暴力、色情或仇恨言论的内容。',
          interference: '您不得干扰或破坏服务的完整性或性能。'
        }
      },
      intellectualProperty: {
        title: '知识产权',
        content: '您保留对自己上传内容的权利。通过使用服务，您授予 Catoo 必要的许可来托管和处理您的内容。Catoo 保留服务本身的所有权利。'
      },
      termination: {
        title: '终止',
        content: '如果我们发现您违反了这些条款，我们保留随时暂停或终止您账户的权利，恕不另行通知。'
      },
      disclaimer: {
        title: '免责声明',
        content: '服务按“原样”提供，不提供任何形式的保证。Catoo 不保证服务将不间断或无错误。'
      }
    }
};
